import React from 'react';
import { useCart } from '../context/CartContext';
export function HisAndHers() {
  const {
    addToCart
  } = useCart();
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-573">
      <div className="max-w-[1800px] mx-auto" data-id="element-574">
        <header className="mb-20 text-center" data-id="element-575">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-576">
            Coordinated Style
          </span>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-577">
            His & Hers
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-578">
            Matching elegance for couples. Coordinated textiles that tell a
            shared story.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-579">
          <div className="aspect-[4/5] bg-grey-divider overflow-hidden grayscale hover:grayscale-0 transition-all duration-700" data-id="element-580">
            <img src="https://cdn.magicpatterns.com/uploads/wuY83ouTkEvEoiTmSETLUt/image.png" className="w-full h-full object-cover" alt="His and Hers" data-id="element-581" />
          </div>
          <div className="flex flex-col justify-center space-y-8" data-id="element-582">
            <h2 className="text-xl sm:text-2xl md:text-4xl font-display font-bold tracking-widest uppercase" data-id="element-583">
              The Union Set
            </h2>
            <p className="text-sm md:text-base font-light tracking-widest text-black/70 leading-relaxed uppercase" data-id="element-584">
              Hand-woven Kente coordinated for both. A symbol of unity and
              shared heritage.
            </p>
            <button onClick={() => addToCart({
            id: 'his-hers-union-set',
            name: 'The Union Set',
            price: '$1200.00',
            image: 'https://cdn.magicpatterns.com/uploads/wuY83ouTkEvEoiTmSETLUt/image.png',
            quantity: 1,
            size: 'OS'
          })} className="bg-black text-white px-10 py-4 text-xs font-display uppercase tracking-widest self-start hover:bg-black/80 transition-colors" data-id="element-585">
              Shop the Set
            </button>
          </div>
        </div>
      </div>
    </div>;
}